export default __webpack_public_path__ + "static/media/knife.9009a95b.png";